ContactsHandler = App.loadClass "grower::handlers/contacts/Contacts_Handler
"
class exports.Confirm_Tab_Handler extends ContactsHandler
    init: () ->
        @layoutUrl = "backend/grower/contacts/confirmtab/load-layout"
        @layoutSelector = "#contactstab_confirm"

        msgwriter = App.sidebar.messageWriter()
        msgwriter.message_writer()
        msgwriter.message_writer('info', 'Loading...')

        @loadLayout()

    afterLoadLayout: (selector, data) ->

        ths = this


        ## Set up Listeners on the Permission DDMs ##
        $(@layoutSelector).find('.sel-permission').change(
            { 'ths': ths },
            ths.permissionListener
        )


        ## Set up Listener for Ignore Buttons ##
        $(@layoutSelector).find('.ignore-btn').click( (e) ->
            btn = $(this)
            $.post(
                'backend/grower/contacts/confirmtab/ignorecontact-ajax',
                { 'contact_id': btn.data('contact_id') },
                (json) ->
                    if(json.status.type is 'success')
                        btn.parents('tr').empty().append("<td class='removal_success'>Request Ignored</td> <td></td> <td></td>")
                    else
                        #alert("ERROR: could not ignore contact request.   Technical Details--> (#{json.status.type}, #{json.status.msg})")
                        App.current_page.refreshSubHandlers()
            )
        )


        ## Set up Listener for Block Buttons ##
        $(@layoutSelector).find('.block-btn').click( (e) ->
            btn = $(this)
            $.post(
                'backend/grower/contacts/confirmtab/blockcontact-ajax',
                { 'contact_id': btn.data('contact_id') },
                (json) ->
                    if(json.status.type is 'success')
                        btn.parents('tr').empty().append("<td class='removal_success'>User Blocked</td> <td></td> <td></td>")
                    else
                        #alert("ERROR: could not block user.   Technical Details--> (#{json.status.type}, #{json.status.msg})")
                        App.current_page.refreshSubHandlers()
            )
        )


        @tabLoadLayoutCallback(selector, data)




    permissionListener: (event) ->
        ths = event.data.ths

        sel = $(this)

        tr = sel.parents('tr')
        original = tr.html()

        contact_id = sel.data('contact_id')
        contact_name = sel.data('contact_name')
        permission_id = sel.val()

        sel.replaceWith('<text class="saving">Saving...</text>')

        $.post(
            'backend/grower/contacts/confirmtab/confirmcontact-ajax',
            { 'contact_id': contact_id, 'permission_id': permission_id }
            (json) ->
                if(json.status.type is 'success')
                    #alert("Note, select changes to saving, while saving.\n (Comment out to see how fast this happens)")
                    confirmed = "<text class='contact_success'>Contact Confirmed!</text>"
                    undo = "<a class='a-undo' data-contact_id=#{contact_id} data-permission_id=#{permission_id}>(Undo)</a>"
                    tr.empty().append("<td colspan='3'> #{confirmed} &nbsp;&nbsp;&nbsp;&nbsp; #{undo} </td>")
                    #ths.setUndoListener(tr, original)
                    tr.find('.a-undo').bind(
                        "click",
                        { 'tr': tr, 'original': original, 'ths': ths },
                        ths.undoListener
                    )
                else
                    #alert("ERROR: could not confirm contact.   Technical Details-->(#{json.status.type}, #{json.status.msg})")
                    App.current_page.refreshSubHandlers()
        )




    undoListener: (event) ->
        ths = event.data.ths
        tr = event.data.tr
        original = event.data.original

        event.preventDefault()
        a = $(this)
        contact_id = a.data('contact_id')
        permission_id = a.data('permission_id')
        $.post(
            'backend/grower/contacts/confirmtab/undoconfirm-ajax',
            { 'contact_id': contact_id, 'permission_id': permission_id }
            (json) ->
                if(json.status.type is 'success')
                    #alert("Note, select changes to saving, while saving.\n (Comment out to see how fast this happens)")
                    tr.empty().append(original)
                    tr.find('.sel-permission').bind(
                        "change",
                        { 'ths': ths },
                        ths.permissionListener
                    )
                else
                    #alert("ERROR: could not confirm contact.   Technical Details-->(#{json.status.type}, #{json.status.msg})")
                    App.current_page.refreshSubHandlers()
        )



